export default "__VITE_ASSET__671b6c63__"